import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteCart,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";
import DetailsCartTable from "./DetailsCartTable";
import LoadingSpinner from "../../../animation/LoadingSpinner";
import BoxEmpty from "../../../boxDetials/boxEmpty";

const PackedCart = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingProducts, setEditingProducts] = useState(null);
  const dispatch = useDispatch();
  const { allCarts, loading, error } = useSelector((state) => state.carts);
  const { t } = useTranslation();
  const [searchBox, setSearchBox] = useState("");

  const headers = [
    "ID",
    "Box. No",
    "Name",
    "Phone",
    "Status",
    "Area",
    // 'Notes',
    "Check Order",
    "Ship_comp",
    "Address",
    "Created At",
    "Weight",
    "Pric_\nPacking",
    "Tot_pric",
    "Actions",
    "Prod",
  ];

  const refreshData = () => {
    dispatch(fetchAllCarts(["packed"]));
  };

  useEffect(() => {
    dispatch(fetchAllCarts(["packed"]));
  }, [dispatch]);

  const handleDelete = (cartId) => {
    if (window.confirm("Are you sure you want to delete this Cart?")) {
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts(["packed"]));
        })
        .catch((error) => alert(error || "Failed to delete Cart."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCarts(["packed"]));
  };

  const packedCartsBefore = allCarts.filter((cart) => cart.status === "packed");
  const packedCarts = allCarts
    .filter((cart) => cart.status === "packed")
    .filter((cart) =>
      cart.referenceCode?.toLowerCase().includes(searchBox.toLowerCase())
    );
  // console.log(packedCarts)

  if (loading && packedCartsBefore.length === 0) {
    return <LoadingSpinner />;
  }

  if (packedCartsBefore.length === 0) {
    return <BoxEmpty title="Not Found Orders" />;
  }
  // console.log(packedCarts)
  return (
    <Table
      title={t("Packed Orders")}
      headers={headers}
      data={packedCarts}
      searchBox={searchBox}
      setSearchBox={setSearchBox}
      renderRow={(cart, index) => (
        <DetailsCartTable
          key={cart._id || index}
          index={index + 1}
          details={{
            id: cart._id,
            number: index + 1,
            boxNumber: cart.referenceCode,
            Name: cart.user?.name,
            phone: cart.user?.phone,
            countryCode: cart.user?.countryCode,
            status: cart.status,
            note: cart.notesAdmin,
            history: cart.createdAt,
            products: cart.products,
            DShippingFees: cart.totalDShippingFees,
            markaShipFees: cart.markaShipFees,
            paymentStatus: cart.paymentStatus,
            timeLeft: cart.timeLeft,
            totalCartPrice: cart.totalCartPrice,
            totalCartPriceBeforeFees: cart.totalCartPriceBeforeFees,
            totalWeight: cart.totalWeight,
            area: cart.area,
            totalPackingFees: cart.totalPackingFees,
            isCheck: cart.isCheck,
            companyName: cart.shippingCompany.companyName,
            address: cart.address,
            paymentPDF: cart.paymentPDF,
            PackagePDF: cart.PackagePDF,
          }}
          isEditing={editingOrder === cart._id}
          setEditingOrder={setEditingOrder}
          isProducts={editingProducts === cart._id}
          setEditingProducts={setEditingProducts}
          onDelete={() => handleDelete(cart._id)}
          onUpdate={handleUpdate}
          refreshData={refreshData}
          loading={loading}
        />
      )}
    />
  );
};

export default PackedCart;
